import { DataSourceMode } from "@mcleod/components/src/databinding/DataSource";
import { AutogenLayoutCompanyImage } from "./autogen/AutogenLayoutCompanyImage";

export class CompanyImage extends AutogenLayoutCompanyImage {
    override onLoad(): void | Promise<void> {
        this.attachmentCompanyImage.setAttachmentWithUI = (file: File) => {
            const maxSize = this.attachmentCompanyImage.maxSize;
            const fileName = file.name.toLowerCase();
            if (!fileName.endsWith(".jpg") && !fileName.endsWith(".jpeg") && !fileName.endsWith(".png") && !fileName.endsWith(".gif"))
                return this.showTooltip("The file must be an image.", { shaking: true, timeout: 5000 });
            else if (maxSize != null && file.size > maxSize)
                return this.showTooltip("The file is too big to attach. The file must be smaller than " + this.attachmentCompanyImage.maxSize / (1024 * 1024) + "MB.", { shaking: true, timeout: 5000 });
            else {
                this.attachmentCompanyImage.setFile(file);
            }
        }

        this.attachmentCompanyImage.updateIfBound = () => {
            if (this.attachmentCompanyImage["_boundField"] != null) {
                let row = null;
                if (this.attachmentCompanyImage.dataSource != null && this.attachmentCompanyImage.dataSource.activeRow != null)
                    row = this.attachmentCompanyImage.dataSource.activeRow;
                else if (this.attachmentCompanyImage.boundRow != null)
                    row = this.attachmentCompanyImage.boundRow;
                if (row != null) {
                    this.attachmentCompanyImage.updateBoundData(row, DataSourceMode.UPDATE);
                }
            }
        }
    }
}
